<template>
  <div id="page1">
    <p class="p-a">付款结果</p>
    <div v-if="this.$route.query.payment_result === 'success'">
      <div style="color: #2185d0; font-weight: bold;">
        购买成功
      </div>
      <div v-if="this.$route.query.category === 'product'">
        <table border="1" style="width: 80%; border: none;">
          <tr>
            <td style="text-align: left; width: 15%; border: none;">商户订单号</td>
            <td style="text-align: left; width: 85%; border: none;">{{ this.$route.query.order_id }}</td>
          </tr>
          <tr>
            <td style="text-align: left; width: 15%; border: none;">用户名</td>
            <td style="text-align: left; width: 85%; border: none;">{{ this.$route.query.username }}</td>
          </tr>
          <tr>
            <td style="text-align: left; width: 15%; border: none;">购买时间</td>
            <td style="text-align: left; width: 85%; border: none;">{{ this.$route.query.gmt_payment }}</td>
          </tr>
        </table>
        <div style="margin-top: 20px;">
          请点击&nbsp;<a href="https://bownetsoft.cn/account" class="my-link">我的账户</a>&nbsp;下载激活码
        </div>
        <div style="color: red; font-weight: bold;">
          我们会尽快安排为您发货
        </div>
      </div>
      <div v-if="this.$route.query.category === 'plan'">
        <table border="1" style="width: 80%; border: none;">
          <tr>
            <td style="text-align: left; width: 15%; border: none;">商户订单号</td>
            <td style="text-align: left; width: 85%; border: none;">{{ this.$route.query.order_id }}</td>
          </tr>
          <tr>
            <td style="text-align: left; width: 15%; border: none;">用户名</td>
            <td style="text-align: left; width: 85%; border: none;">{{ this.$route.query.username }}</td>
          </tr>
          <tr>
            <td style="text-align: left; width: 15%; border: none;">流量套餐生效时间</td>
            <td style="text-align: left; width: 85%; border: none;">{{ this.$route.query.nbf }}</td>
          </tr>
          <tr>
            <td style="text-align: left; width: 15%; border: none;">流量套餐结束时间</td>
            <td style="text-align: left; width: 85%; border: none;">{{ this.$route.query.exp }}</td>
          </tr>
        </table>
      </div>
      <div v-if="this.$route.query.category === 'custom'">
        <table border="1" style="width: 80%; border: none;">
          <tr>
            <td style="text-align: left; width: 15%; border: none;">商户订单号</td>
            <td style="text-align: left; width: 85%; border: none;">{{ this.$route.query.order_id }}</td>
          </tr>
          <tr>
            <td style="text-align: left; width: 15%; border: none;">用户名</td>
            <td style="text-align: left; width: 85%; border: none;">{{ this.$route.query.username }}</td>
          </tr>
          <tr>
            <td style="text-align: left; width: 15%; border: none;">您购买了1台</td>
            <td style="text-align: left; width: 85%; border: none;">{{ this.$route.query.prodname }}</td>
          </tr>
          <tr>
            <td style="text-align: left; width: 15%; border: none;">您为该设备设定的IP地址为</td>
            <td style="text-align: left; width: 85%; border: none;">{{ this.$route.query.customip }}</td>
          </tr>
        </table>
        <div style="margin-top: 20px; color: red; font-weight: bold;">
          我们会尽快安排为您发货
        </div>
      </div>
    </div>
    <div v-if="this.$route.query.payment_result === 'fail'">
      <div>
        购买失败
      </div>
      <table border="1" style="width: 80%; border: none;">
        <tr>
          <td style="text-align: left; width: 12%; border: none;">出错信息</td>
          <td style="text-align: left; width: 88%; border: none;">{{ this.$route.query.describe }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Payment',
  data() {
    return {
    }
  }
}
</script>

<style scoped>
#page1{
  margin-left: 110px;
  padding: 0;
  height: 600px;
  width: 90%;
}

.my-link {
  color: blue; /* 设置颜色为蓝色 */
  text-decoration: none; /* 去除下划线 */
}

.p-a {
  margin-top: 25px;
  margin-bottom: 10px;
  color: #2185d0!important;
  font-weight: bold;
  font-size: 24px;
}

.button-demo {
  display:block;
  width:50px;
  height:24px;
  border-radius:2px;
  line-height: 25px;
  border:none;
  background-color:#1DA1F2;
  color:#fff;
  font-size:14px;
}

.message {
  color: red;
  margin-left: 3px;
}
</style>
